import { AuditLogTable } from "@nwga/features/admin/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/audit")({
	component: AdminAuditPage,
});

function AdminAuditPage() {
	return (
		<div className="space-y-6">
			<div>
				<h1 className="font-semibold text-2xl tracking-tight">Audit log</h1>
				<p className="mt-1 text-muted-foreground text-sm">
					Every approval, suspension, removal and role change, with who did it.
					Append-only — nothing in the product edits or deletes these entries.
				</p>
			</div>

			<AuditLogTable pageSize={50} />
		</div>
	);
}
